exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".other-filings table tbody tr:last-child td{border-bottom:0}.other-filings .case-label{text-align:center;margin:20px 0}.other-filings .messages{margin-bottom:30px}.other-filings .live_search{margin-top:15px;margin-bottom:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/case/associated_cases/OtherFilings.less
// module id = 1609
// module chunks = 0